import { LOCATION_PLACE_TYPE } from 'types/services';
import { IShipmentData } from '../types/orders';

export const defaultPlace = (shipment: IShipmentData) => {
  if (shipment?.place === LOCATION_PLACE_TYPE.USER) return shipment?.receiverInfo?.receiverName;
  if (shipment?.place === LOCATION_PLACE_TYPE.OFFICE) return `Oficinas ${shipment?.receiverInfo?.receiverName}`;
  if (shipment?.place === LOCATION_PLACE_TYPE.NUDOS) return `Bodegas ${shipment?.country?.name}`;
  return '';
};
